import GlobalStyle from "../../../GlobalStyle";
import React from "react";
import SendIcon from "../../../assets/img/CuratedContent/Send.svg";
import styled from "styled-components";

const ButtonRightIcon = (props) => {
  const { label, icon, green, active, onClick, noIcon, disable } = props;
  return (
    <>
      <GlobalStyle />
      <Btn
        onClick={onClick}
        green={green}
        className={`${props.outlineClass} ${disable ? "disabled less-opaque" : ""}`}
        {...props}
      >
        <span className="label">{label}</span>
        {noIcon ? null : (
          <span className="icon">
            {green ? <img src={icon} alt="icon" /> : <img src={icon} alt="icon" />}
            {/* <object type="image/svg+xml" data={icon}></object> */}
          </span>
        )}
      </Btn>
    </>
  );
};

ButtonRightIcon.defaultProps = {
  label: "Curation History",
};

export default ButtonRightIcon;

const Btn = styled.button`
  cursor: pointer;
  &:hover {
    background-color: #27ce0a;
    color: #fff;
    span.icon {
      filter: invert(0) sepia(0) saturate(1) hue-rotate(0deg) brightness(5);
    }
  }
  &:disabled {
    opacity: 0.7;
    pointer-events: none !important;
  }
  &.less-opaque {
    opacity: 0.5 !important;
  }
  border-radius: 8px;
  background-color: ${(props) => (props.green ? "#27CE0A" : "#fff")};
  color: ${(props) => (props.green ? "#fff" : "#7E7E7E")};
  font-size: 16px;
  font-weight: 500;
  padding: 0 2px 0 16px;
  line-height: 20px;
  border: solid 1px #dadada;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "robotomedium";
  // margin-top: 3px;
  /* height: 41px; */
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    font-size: 12px;
    line-height: 14px;
    border-radius: 6px;
    /* height: 31px; */
    margin-top: 0px;
    padding: 0 2px 0 10px;
  }
  &:hover {
    span.label {
      color: #fff;
    }
  }
  /* @media all and (max-width: 1125px) {
    padding: 0 2px 0 5px;
    font-size: 10px;
    height: 26px;
  } */
  span.label {
    padding: 2px 0;
    float: left;
    margin-right: 13px;
    min-width: 65px;
    white-space: nowrap;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      min-width: auto;
    }
    /* @media all and (max-width: 1125px) {
      margin-right: 5px;
    } */
  }
  span.icon {
    display: flex;
    border-left: 1px solid #dddddd;
    padding: 1px 5px;
    margin: 8px 0px;
    float: left;
    filter: ${(props) => (props.green ? "invert(0) sepia(0) saturate(1) hue-rotate(0deg) brightness(5)" : "none")};
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin: 6px 0px;
    }
    svg {
      float: left;
    }
  }
  &.auto-width {
    span.label {
      min-width: auto;
    }
    span.icon {
      padding: 1px 8px;
    }
  }
  &.green-outline {
    border-color: #27ce0a;
    .label {
      color: #27ce0a;
    }
    .icon {
      border-color: #27ce0a;
    }
    &:hover {
      background-color: #27ce0a;
      .label {
        color: #fff;
      }
      span.icon {
        filter: invert(0) sepia(0) saturate(1) hue-rotate(0deg) brightness(5);
      }
    }
  }
`;
